import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_3 = { class: "inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-6xl sm:w-full sm:p-6" }
const _hoisted_4 = { class: "mt-2 text-center sm:mt-5" }
const _hoisted_5 = { class: "items-center" }
const _hoisted_6 = { class: "mt-6 pb-2 text-left overflow-x-auto" }
const _hoisted_7 = { class: "mt-5 sm:mt-6" }

import { computed, inject, ref, shallowRef, watch } from "vue";
import {
  Dialog,
  DialogTitle,
  DialogOverlay,
  TransitionRoot,
  TransitionChild,
} from "@headlessui/vue";
import DataTable from "../tools/DataTable.vue";
import Pagination from "../tools/Pagination.vue";
import dayjs from "dayjs";
import { formatNumber, translate } from "@/utils/tools";
import { useRouter } from "vue-router";
import { AxiosInstance } from "axios";
import { useStore } from "vuex";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserSubEventDialog',
  props: { id: Object, show: Boolean },
  emits: ["submit", "pageChange", "update:show", "update:form"],
  setup(__props, { emit }) {

const props = __props

const axios = inject("$axios") as AxiosInstance;
const route = useRoute();
const store = useStore();

const dataRows = ref([]);

const showSync = computed({
  get: () => props.show,
  set: (value) => emit("update:show", value),
});

const pageConfig = ref({
  page: 1,
  count: 0,
  pageCount: 0,
  rowsPerPage: 10,
  dataLength: 0,
  search: undefined,
  sort: [["created_at", "DESC"]],
});

const columns = [
  {
    label: translate("messages.event.subEventName"),
    field: "sub_event_name",
    isSorted: true,
  },
  {
    label: translate("messages.event.settleAmount"),
    field: "settle_amount",
  },
  {
    label: translate("messages.event.settleCount"),
    field: "settle_count",
  },
  {
    label: translate("messages.event.validAmount"),
    field: "valid_amount",
  },
  {
    label: translate("messages.event.roundCount"),
    field: "round_count",
  },
  {
    label: translate("messages.event.success"),
    field: "is_success",
    class: (data: any) => {
      if (data.is_success) {
        return "inline-block text-xs py-1 px-2 rounded-lg bg-green-500 text-white";
      }
      return "inline-block text-xs py-1 px-2 rounded-lg bg-red-500 text-white";
    },
  },
];

const fetchPageData = async () => {
  const { page, rowsPerPage, sort, search } = pageConfig.value;

  const payload = {
    user_event_id: props.id,
    page,
    operatorId: store.state.selectedOperator.operatorId,
    name: search || null,
    pageSize: rowsPerPage,
    orderBy: [sort[0]],
  };
  // console.log("payload : ", payload);
  const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/event/api/user-sub-events/list`;
  const { rows } = await axios
    .post(url, payload, {
      headers: {
        "x-cm-operator-id": store.state.selectedOperator.operatorId,
      },
    })
    .then(({ data }) => data);

  dataRows.value = dataRows.value = rows.map((obj: any) => {
    return {
      ...obj,
      settle_amount: obj.config[0].target_settle_amount + "/" + obj.config[0].current_settle_amount,
      settle_count: obj.config[0].target_settle_count + "/" + obj.config[0].current_settle_count,
      valid_amount: obj.config[0].target_valid_amount + "/" + obj.config[0].current_valid_amount,
      round_count: obj.config[0].target_round_count + "/" + obj.config[0].current_round_count,
    };
  });
  pageConfig.value.dataLength = rows.length;

  // console.log("data event reward : ", dataRows.value);

  pageConfig.value = {
    ...pageConfig.value,
  };

  // selectedRow.value = {};
};

watch(
  () => pageConfig.value.page,
  () => {
    emit("pageChange", {
      limit: pageConfig.value.rowsPerPage,
      page: pageConfig.value.page,
    });
  }
);

watch(
  () => pageConfig.value.rowsPerPage,
  () => {
    pageConfig.value.page = 1;
    emit("pageChange", {
      limit: pageConfig.value.rowsPerPage,
      page: pageConfig.value.page,
    });
  }
);
watch(showSync, async (val) => {
  if (val) {
    fetchPageData();
  }
});



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(TransitionRoot), {
      as: "template",
      show: _unref(showSync),
      static: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          as: "div",
          static: "",
          class: "fixed z-10 inset-0 overflow-y-auto",
          onClose: _cache[2] || (_cache[2] = ($event: any) => (showSync.value = false)),
          open: _unref(showSync)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogOverlay), { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
                ]),
                _: 1
              }),
              _hoisted_2,
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_unref(DialogTitle), {
                          as: "h3",
                          class: "text-lg leading-6 font-medium text-gray-900 flex flex-row justify-between items-center"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("messages.event.userSubEvent")), 1)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(DataTable, {
                            class: "mx-auto",
                            columns: columns,
                            data: dataRows.value
                          }, null, 8, ["data"]),
                          _createVNode(Pagination, {
                            config: pageConfig.value,
                            "onUpdate:config": _cache[0] || (_cache[0] = ($event: any) => ((pageConfig).value = $event))
                          }, null, 8, ["config"])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('submit'))),
                        class: "mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                      }, " close ")
                    ])
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["open"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})